import { render } from "./MyInbox.vue?vue&type=template&id=b20a54c0&scoped=true"
import script from "./MyInbox.vue?vue&type=script&lang=js"
export * from "./MyInbox.vue?vue&type=script&lang=js"

import "./MyInbox.vue?vue&type=style&index=0&id=b20a54c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20a54c0"]])

export default __exports__